module.exports = __webpack_public_path__ + "static/img/44_pear.f94b7e87.jpg";